import { render, staticRenderFns } from "./ErrorForApiComponent.vue?vue&type=template&id=1c9f2eb4&"
import script from "./ErrorForApiComponent.vue?vue&type=script&lang=ts&"
export * from "./ErrorForApiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports